import { GetHostDashboardDataQuery } from '@website/types/graphqlOperations';
import React from 'react';
import { Alert } from 'react-bootstrap';
import Link from 'next/link';

interface HostSignUpSectionsChecklistProps {
  host: GetHostDashboardDataQuery['hostByURL'];
}

export function HostMissingSettingsAlerts({
  host,
}: HostSignUpSectionsChecklistProps) {
  const isBusinessInfoAvailable = !!(host.businessAddress && host.legalName);
  const isPaymentInfoAvailable =
    !!host.paymentDetails && !!host.paymentDetails?.bankDetails;

  return (
    <>
      {!isBusinessInfoAvailable && (
        <Alert variant="warning">
          Please complete your business information{' '}
          <Link href={`/hosts/dashboard/${host.urlSlug}/edit/business`}>
            here
          </Link>
          .
        </Alert>
      )}
      {!isPaymentInfoAvailable && (
        <Alert variant="warning">
          Please complete your payment information{' '}
          <Link href={`/hosts/dashboard/${host.urlSlug}/edit/payments`}>
            here
          </Link>
          .
        </Alert>
      )}
    </>
  );
}
